<template>
    <div v-if="questions">
                                    
        <div class="mb-4">
            <b-alert
                :show="dismissCountDown"
                dismissible
                fade
                :variant="response.success === true ? 'success' : 'danger' "
                @dismissed="dismissCountDown = 0">
                {{response.message}}
            </b-alert>
            <div v-for="(question, qIndex) in questions" :key="qIndex">
                <div class="card-body form-group">
                    <div style="padding-left: 1rem;" class="row">
                        <h5 class="question">{{question.questionText}}<span v-if="question.required" class="text-red">*</span></h5>
                        <b-button v-if="question.showHelpButton" v-b-tooltip.hover class="ml-2 question-help-btn" :title="$t('ADDITIONAL_INFORMATION')" @click="showQuestionAdditionalInformation(question)">
                            <icon icon="question-circle" />
                        </b-button>
                    </div>
                    <!-- Multiple Choice -->
                    <div v-if="question.type == 1">
                        <div class="container mt-3">
                            <div class="row btn-group btn-group-toggle" data-toggle="buttons">
                                <div 
                                    @click="OnAnswerClick(question.id, answer.id)" 
                                    class="btn btn-multiple-choice form-check-label" v-bind:class="[isActive(question.id, answer.id) ? 'btn-success active' : 'btn-secondary'  ]"
                                    v-for="(answer,aIndex) in question.answers" :key="qIndex*100 + aIndex">
                                    <input type="radio" :checked="isActive(question.id, answer.id)" autocomplete="off" />{{answer.answerText}}                        
                                </div>
                            </div>    
                        </div>
                    </div>
                    <!-- Free Text -->
                    <div v-else-if="question.type == 2" class="mt-3">
                        <b-form-textarea
                            v-if="patientTextAnswerCondition(question.id)"
                            v-model="patientAnswers[patientAnswers.map(function(item) { return item.questionId; }).indexOf(question.id)].textAnswer"
                            placeholder="Enter something..."
                            rows="4"
                            max-rows="8">
                        </b-form-textarea>
                    </div>
                    <!-- Checkboxes -->
                    <div v-else-if="question.type == 3">
                        <h6 class="mb-3 question-type-text">{{$t('MULTISELECT_HELP')}}</h6>
                        <div class="container">
                            <div class="row btn-group btn-group-toggle d-block" >
                                <div v-for="(answer,aIndex) in question.answers" :key="qIndex*100 + aIndex">
                                    <div class="form-check-inline">
                                        <input 
                                            @change="checkBoxChanged($event, question.id, answer.id)"
                                            type="checkbox" 
                                            :checked="isChecked(question.id, answer.id)" 
                                            autocomplete="off"
                                            :id="answer.answerText + aIndex" class="form-check-input"> 
                                        <label :for="answer.answerText + aIndex" class="form-check-label">{{answer.answerText}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>    
                    </div>
                </div>
            </div>
            <div>
                <button v-if="isRequiredQuestionsAreAnswered" @click="updatePatientAnswers();" type="button" class="btn btn-success ml-4 mb-3">{{$t('SAVE')}}</button>
                <p class="p-3 text-center text-red" v-else>{{$t('ALL_REQUIRED_QUESTION_MUST_BE_ANSWERED_BEFORE_SUBMIT')}}</p>
            </div>
            
        </div>
        <modal :title="$t('QUESTION_ADDITIONAL_INFORMATION')" v-if="showQuestionHelpModal" @close="showQuestionHelpModal = false">
            <template v-slot:body>
                <span v-dompurify-html="modalQuestionAdditionalInformation"></span>
            </template>
            <template v-slot:footer>
                <span></span>
            </template>
        </modal>
    </div>
</template>
<script>
import Modal from './../../misc/Modal.vue';

export default {
    props: {
        questions: Array
    },
    components: {
        'modal': Modal
    },
    data() {
        return {
            response: {},
            dismissCountDown: 0,
            modalQuestionAdditionalInformation: null,
            showQuestionHelpModal: false,
        }
        
    },
    computed: {
        cgaPatientSheet: function(){
            return this.$store.getters.cgaPatientSheet;
        },
        patientAnswers: function(){
            return this.$store.getters.patientAnswers;
        },
        languages: function(){
            return this.$store.getters.systemLanguages;
        },
        languagesMap: function(){
            return this.languages.reduce(function(map, obj){
                map[obj.id] = obj.longTitle;
                return map
            }, {});
        },
        selectedLanguage: function(){
            return this.$store.getters.selectedLanguage;
        },
        cgaPatient: function(){
            return this.$store.getters.cgaPatient;
        },
        stepSequences: function(){
            return this.$store.getters.stepSequences;
        },
        step: function(){
            return this.$store.getters.step;
        },
        requiredQuestions() {
            return this.questions.filter(function(obj){
                return obj.required == true;
            });
        },
        isRequiredQuestionsAreAnswered() {
            let result = true;
            let self = this;
            for (let i = 0; i < this.requiredQuestions.length; i++) {
                let foundQuestionPatientAnswer = false;
                for (let j = 0; j < this.$store.getters.patientAnswers.length; j++) {
                    if (this.$store.getters.patientAnswers[j].questionId == this.requiredQuestions[i].id) {
                        foundQuestionPatientAnswer = true;
                        break;
                    }
                }

                result = result && foundQuestionPatientAnswer;
            }

            return result;
        }
    },
    methods: {
        showQuestionAdditionalInformation(question) {
            this.showQuestionHelpModal = !this.showQuestionHelpModal;
            if (this.showQuestionHelpModal) {
                this.modalQuestionAdditionalInformation = question.help;
                if (question.help == null || question.help.length == 0) {
                    this.modalQuestionAdditionalInformation = this.$t('THERE_IS_NO_ADDITIONAL_INFORMATION');
                }
            }
        },
        updatePatientAnswers: function(){
            let self = this;
            this.$store.dispatch("updatePatientAnswers")
            .then(response => {
                self.response.message = response.data.message;
                self.addProgressLog();
            })
            .catch(error => {
                console.log(error);
            });

        },
        patientTextAnswerCondition(questionId) {
            let patientAnswerExists = (this.patientAnswers.map(function(item) { return item.questionId; }).indexOf(questionId) >= 0);
            if (patientAnswerExists == false) {
                this.$store.dispatch("initPatientTextAnswer", questionId);
            }

            return true;
        },
        addProgressLog : function(){
            let self = this;
                this.$http.post(`/api/category-steps/${this.step.id}/progress-logs/update/${this.cgaPatientSheet.id}`)
                .then(response => {
                    let tempResponse = {};
                    tempResponse.success = response.data.success;
                    tempResponse.message = self.response.message
                    self.response = tempResponse;
                })
                .catch(error => {
                    console.log(error);
                })
        },
        OnAnswerClick: function(questionId, answerId)
        {   
            var isQuestionAnswered = false;
            this.patientAnswers.forEach(element => {
                if(element.questionId === questionId){
                    isQuestionAnswered = true;
                    element.answerId = answerId;
                }
            });

            if(!isQuestionAnswered)
            {
                var newPatientAnswer = {
                    "questionId": questionId,
                    "patientId": this.cgaPatient.id,
                    "answerId": answerId,
                    "patientSheetId": this.cgaPatientSheet.id
                }
                this.patientAnswers.push(newPatientAnswer);
            }
        },
        isActive: function(questionId, answerId)
        {
            var patientAnswerIndex = this.patientAnswers.map(function(item) { return item.questionId; }).indexOf(questionId);
            if(patientAnswerIndex >= 0 && this.patientAnswers[patientAnswerIndex].answerId === answerId)
                return true;
            else
                return false;
        },
        isChecked: function(questionId, answerId)
        {
            var isAnswerChecked = false;
            this.patientAnswers.forEach(element => {
                if(element.answerId == answerId && element.questionId == questionId)
                    isAnswerChecked = true;
            });
            return isAnswerChecked;
        },
        checkBoxChanged: function(event, questionId, answerId)
        {
            if (event.target.checked) {
                var newPatientAnswer = {
                    "questionId": questionId,
                    "patientId": this.cgaPatient.id,
                    "answerId": answerId,
                    "patientSheetId": this.cgaPatientSheet.id
                }
                this.patientAnswers.push(newPatientAnswer);
            }
            else
            {
                var patientAnswerIndex = this.patientAnswers.map(function(item) { return item.answerId; }).indexOf(answerId);
                if(patientAnswerIndex !== -1){
                    this.patientAnswers.splice(patientAnswerIndex, 1);
                }
            }
        },
        checkScoreAndRedirect: function()
        {
            var totalScore = 0;
            var self = this;
            this.patientAnswers.forEach(patientAnswer => {
                self.questions.forEach(question => {
                    if(patientAnswer.questionId === question.id)
                    {
                        question.answers.forEach(answer => {
                            if(patientAnswer.answerId === answer.id)
                            {
                                totalScore = totalScore + answer.score;
                            }
                        })
                    }
                })
            })
            console.log('score: ' + totalScore);
            var isRedirected = false;
            for(let stepSeqIndex = 0; stepSeqIndex < this.stepSequences.length; stepSeqIndex++)
            {
                if(this.stepSequences[stepSeqIndex].previousStepId === this.$route.params.stepId
                    && totalScore >= this.stepSequences[stepSeqIndex].minimumScore 
                    && totalScore <= this.stepSequences[stepSeqIndex].maximumScore )
                {
                    //console.log('Redirecting to another step');
                    self.$router.push(`/categories/${self.$route.params.categoryId}/steps/${this.stepSequences[stepSeqIndex].nextStepId}`)
                    isRedirected = true;
                    break;
                }
            }
            if(!isRedirected){
                //console.log('Redirecting to steps');
                self.$router.push(`/categories/${self.$route.params.categoryId}`);
            }

        },
        loadRequiredQuestionFlags() {
            for (let i = 0; i < this.questions.length; i++) {
                if (this.questions[i].required) {
                    this.requiredQuestionFlags.push(this.questions[i].id);
                }
            }
        },
        setShowHelpButtonPropertyToQuestions() {
            this.questions.forEach(question => {
                if (question.help === null || !question.help || question.help === '') {
                    question.showHelpButton = false;
                } else {
                    question.showHelpButton = true;
                }
            });
        }
    },
    mounted: function() {
        this.setShowHelpButtonPropertyToQuestions();
    },
    watch: {
        response: function(val){
            this.dismissCountDown = 1.5;
            var self = this;
            if(val.success === true)
            {
                setTimeout(function(){ self.checkScoreAndRedirect(); }, 500);
                
            }
        }
    }
}
</script>
<style lang="scss" scoped>

h5 {
    font-size: 1.2em;
}
h5.question{
    margin-bottom: 0.15rem;
    color: black;
}
div.container{
  padding-left: 0rem;
  margin-left: 1rem;
}
.question-help-btn {
    background-color: transparent !important;
    border: none !important;
    background: none !important;
    box-shadow: none !important;
    padding: 2px;
}
.question-type-text {
    font-size: 14px !important;
}
input {
    -ms-transform: scale(1.2);
    -moz-transform: scale(1.2);
    -webkit-transform: scale(1.2);
    -o-transform: scale(1.2);
    transform: scale(1.2);
}
label {
    font-size: 1.1em;
}

// IE styles
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .btn-multiple-choice {
        background-color: transparent;
        &:hover {
            background-color: transparent;
        }
    }
}
</style>